'use client';

import React, { useEffect, useState } from 'react';

const TEST_MODE_PARAM_KEY = 'test_mode';
const TEST_MODE_SESSION_KEY = 'test_mode';

export interface TestModeContextValues {
  isTestMode: boolean;
}

const getIsTestMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(TEST_MODE_SESSION_KEY) === 'true';
};

export const TestModeContext = React.createContext<TestModeContextValues>({
  isTestMode: getIsTestMode(),
});

export const TestModeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isTestMode, setIsTestMode] = useState(getIsTestMode());

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const testModeParam = urlParams.get(TEST_MODE_PARAM_KEY);

    if (testModeParam) {
      window.sessionStorage.setItem(TEST_MODE_SESSION_KEY, testModeParam);
    }

    setIsTestMode(testModeParam === 'true' || getIsTestMode());
  }, []);

  return (
    <TestModeContext.Provider value={{ isTestMode }}>
      {children}
    </TestModeContext.Provider>
  );
};
